exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Dkcgo{position:relative;width:100%;height:170px;overflow:hidden;padding:0}._3w_xQ{background-color:#f1f1f1}._3w_xQ ._21viN{position:absolute;top:50%;left:50%;width:60%;height:auto;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

// exports
exports.locals = {
	"tmb": "Dkcgo",
	"img": "_21viN imgCover",
	"placeholderImg": "_3w_xQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/Thumb/Thumb.css
// module id = 1467
// module chunks = 0 1 15 17 18 19 20 21 23 24 32 33 36 37 38